import { useModuleBEM } from "@b2bportal/core-themes";
import { Dialog, DialogContent } from "@tenant/ui";
import { EarnPointsDialogContent } from "./EarnPointsDialogContent";
import { PerkDialogButtons } from "./PerkDialogButtons";
import styles from "./PerkDialogs.module.scss";
import { REWARDS_POINTS_FAQ_URL } from "@/utils/externalPages";

interface EarnPointsDialogControlledProps {
  open: boolean;
  onClose: () => void;
}

export const EarnPointsDialogControlled = ({
  open,
  onClose,
}: EarnPointsDialogControlledProps) => {
  const [, cn] = useModuleBEM(styles, "PerkDialogs");

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        bottomFixedContent={
          <PerkDialogButtons rulesUrl={REWARDS_POINTS_FAQ_URL} />
        }
        className={cn("item-dialog-content")}
        showCloseButton={false}
      >
        <EarnPointsDialogContent />
      </DialogContent>
    </Dialog>
  );
};
